export function decimal(value: string | number): string {
  if (typeof value === "string") {
    value = parseFloat(value)
  }
  return value.toFixed(2)
}
